import { createContext } from 'react';
import { StoryblokNode } from '../interfaces/StoryblokNode.interface';
import { StoryblokPartnerSite } from '../interfaces/StoryblokPartnerSite.interface';
import { StoryblokMoveSpecialist } from '../interfaces/StoryblokMoveSpecialist.interface';

interface QuoteStageContextProps {
  partner_sites: StoryblokNode<StoryblokPartnerSite>[];
  move_specialists: StoryblokNode<StoryblokMoveSpecialist>[];
}

export const QuoteStageContext = createContext<QuoteStageContextProps>({
  partner_sites: [],
  move_specialists: [],
});
